module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo_new.4b22f977.mp3";